import React, { useState } from 'react'
import classes from './MyOrders.module.scss'
import TestImageSmall from '../../../../assets/SampleThumbnailImage.png'

const ORDER_STATUS = {
  active: "active",
  cancelled: "cancelled",
  completed: "completed"
}
export default function MyOrders() {
  const [orderStatus, setOrderStatus] = useState(ORDER_STATUS.active)
  const [orders, setOrders] = useState([
    {
      orderId: "1230901",
      orderDate: "10 june 2023",
      estimatedDeliveryDate: "8 June 2023",
      orderStatus: "Shipped",
      paymentMethod: "Cash on delivery",
      orderItems: [
        {
          itemName: "Abaya Red",
          sku: "ABRED123",
          color: "Red",
          quantity: 5,
          price: "234.90",
          itemImage: TestImageSmall,
        },
        {
          itemName: "Abaya Blue",
          sku: "ABRED456",
          color: "Blue",
          quantity: 5,
          price: "434.90",
          itemImage: TestImageSmall,
        },
        {
          itemName: "Abaya Green",
          sku: "ABGREEN123",
          color: "Green",
          quantity: 5,
          price: "534.90",
          itemImage: TestImageSmall,
        },
      ]
    },
    {
      orderId: "123444",
      orderDate: "10 june 2023",
      estimatedDeliveryDate: "8 June 2023",
      orderStatus: "In Progress",
      paymentMethod: "Cash on delivery",
      orderItems: [
        {
          itemName: "Abaya Red",
          sku: "ABRED123",
          color: "Red",
          quantity: 5,
          price: "234.90",
          itemImage: TestImageSmall,
        },
        {
          itemName: "Abaya Blue",
          sku: "ABRED456",
          color: "Blue",
          quantity: 5,
          price: "434.90",
          itemImage: TestImageSmall,
        },
        {
          itemName: "Abaya Green",
          sku: "ABGREEN123",
          color: "Green",
          quantity: 5,
          price: "534.90",
          itemImage: TestImageSmall,
        },
      ]
    },
  ])
  return (
    <div className={classes.MyOrders}>
      <div className={classes.Heading}>My Orders</div>
      <div className={classes.OrderStatusSelector}>
        {Object.keys(ORDER_STATUS).map(status => <div className={`${classes.OrderStatus} ${status === orderStatus ? classes.ActiveOrderStatus : ''}`} onClick={() => setOrderStatus(status)}>{status}</div>)}
      </div>
      <div className={classes.OrderDetailsContainer}>
        {orders.map(order => {
          return (
            <div className={classes.OrderDescriptionAndProducts}>
              <div className={classes.OrderDescription}>
                <div className={classes.OrderDescriptionHeading}>Order no: #{order.orderId}</div>
                <div className={classes.OrderDetailsParticulars}>
                  <div className={classes.OrderDescriptionText}>Order Date : <span className={classes.OrderDescriptionSubText}>{order.orderDate}</span></div>
                  <div className={classes.OrderDescriptionText}>Order Status : <span className={classes.OrderDescriptionSubText}>{order.orderStatus}</span></div>
                  <div className={classes.OrderDescriptionText}>Estimated Delivery Date : <span className={classes.OrderDescriptionSubText}>{order.estimatedDeliveryDate}</span></div>
                  <div className={classes.OrderDescriptionText}>Payment Method : <span className={classes.OrderDescriptionSubText}>{order.paymentMethod}</span></div>
                </div>
              </div>
              <div className={classes.CartProducts}>
                {order.orderItems.map((product) => (
                  <div className={classes.CartProduct}>
                    <div className={classes.CartProductDetails}>
                      <img src={product.itemImage} alt='product' />
                      <div className={classes.CartProductDescription}>
                        <div className={classes.CartItemName}>{product.itemName}</div>
                        <div className={classes.Color}>Color : {product.color}</div>
                        <div>Qty : {product.quantity}</div>
                        <div>Total : {product.price * product.quantity}</div>
                      </div>
                    </div>
                    <div className={classes.OrderProductDetails}>View Details</div>
                  </div>
                ))}
              </div>
            </div>
          )
        })}
      </div>

    </div >
  )
}
